var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppWithLoading',{attrs:{"fetch":_vm.fetch}},[(_vm.quota)?_c('div',[(!_vm.quota.sms)?_vm._t("exceeded"):_vm._t("normal")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }